import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DevelopersPage from './pages/DevelopersPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/main" element={<Navigate to="/" replace />} />
        <Route path="/developers" element={<DevelopersPage />} />
      </Routes>
    </Router>
  );
}

export default App;
